import {
  Flex,
  Text,
  InputProps,
  Input,
  Box,
  useColorModeValue,
  Tooltip,
  InputGroup,
} from '@chakra-ui/react';

import { IMaskInput } from 'react-imask';

interface InputTextProps extends InputProps {
  label?: string;
  labelColor?: string;
  placeholder?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  leftElement?: React.ReactNode;
  type?: string;
  error?: any;
  mask?: any;
  radix?: string;
  scale?: number;
  isReadOnly?: boolean;
  isDisabled?: boolean;
  thousandsSeparator?: string;
  maskOptions?: any;
  required?: boolean;
  toUpperCase?: boolean;
  inputRightAddon?: any;
  inputLeftAddon?: any;
}

export default function InputText({
  label,
  labelColor,
  leftIcon,
  rightIcon,
  inputRightAddon,
  inputLeftAddon,
  leftElement,
  mask,
  radix,
  scale,
  type,
  thousandsSeparator,
  isReadOnly,
  isDisabled,
  maskOptions,
  error,
  required,
  toUpperCase,
  ...rest
}: InputTextProps) {
  const errorColor = useColorModeValue('rgb(155, 0, 0)', 'rgb(250, 100, 100)');
  const borderColor = useColorModeValue('grey.700', 'grey.700');
  const bgColor = useColorModeValue('grey.700', 'white');
  const color = useColorModeValue('gray.800', 'gray.100');
  const colorInput = useColorModeValue('gray.700', 'white');
  return (
    <Flex direction="column" flex={1} width="100%" {...rest}>
      <Flex>
        <Text
          color={labelColor}
          fontSize="18px"
          justify="center"
          fontWeight="medium"
        >
          {label}
        </Text>
        {required === true && <Text color={errorColor}>*</Text>}
      </Flex>
      <Flex
        direction="row"
        width="100%"
        borderColor={error ? errorColor : 'inherit'}
      >
        {leftElement && <Box>{leftElement}</Box>}
        <InputGroup>
          {inputLeftAddon}
          {mask ? (
            <Input
              as={IMaskInput}
              radix={radix}
              scale={scale}
              isDisabled={isDisabled}
              readOnly={isReadOnly}
              leftElement={leftIcon}
              rightIcon={rightIcon}
              thousandsSeparator={thousandsSeparator}
              mask={mask}
              placeholder={
                rest.placeholder ? rest.placeholder : 'Digite aqui...'
              }
              maskOptions={maskOptions}
              color={color}
              onAccept={(val: string) => {
                if (toUpperCase) {
                  const newVal = val.toUpperCase();
                  rest.onChange?.({ target: { value: newVal } } as any);
                }
              }}
              style={{
                borderWidth: '1px',
                width: '100%',
                height: '40px',
                padding: '14px',
                borderRadius: '8px',
                borderTopRightRadius: inputRightAddon ? '0px' : '8px',
                borderBottomRightRadius: inputRightAddon ? '0px' : '8px',
                borderTopLeftRadius: inputLeftAddon ? '0px' : '8px',
                borderBottomLeftRadius: inputLeftAddon ? '0px' : '8px',
                background: 'transparent',
                borderColor: `${borderColor}`,
                color: `${color}`,
                outline: 'none',
              }}
              sx={{
                '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus':
                  {
                    WebkitBoxShadow: 'transparent !important',
                    WebkitTextFillColor: `${colorInput} !important`,
                    transition: 'background-color 9999s ease-in-out 0s',
                  },
              }}
              {...(rest as any)}
            />
          ) : (
            <Input
              flex={1}
              disabled={isDisabled}
              readOnly={isReadOnly}
              // color={isDisabled ? color : 'inherit'}
              color={color}
              // color="black"
              type={type}
              leftIcon={leftIcon}
              onAccept={(val: string) => {
                if (toUpperCase) {
                  const newVal = val.toUpperCase();
                  rest.onChange?.({ target: { value: newVal } } as any);
                }
              }}
              placeholder={
                rest.placeholder ? rest.placeholder : 'Digite aqui...'
              }
              style={{
                borderRadius: '8px',
                borderTopRightRadius: inputRightAddon ? '0px' : '8px',
                borderBottomRightRadius: inputRightAddon ? '0px' : '8px',
                borderTopLeftRadius: inputLeftAddon ? '0px' : '8px',
                borderBottomLeftRadius: inputLeftAddon ? '0px' : '8px',
              }}
              sx={
                type === 'date'
                  ? {
                      '::-webkit-calendar-picker-indicator': {
                        display: 'inline',
                        WebkitAppearance: 'inline',
                      },
                      '::-moz-calendar-picker-indicator': {
                        display: 'inline',
                      },
                    }
                  : {
                      '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus':
                        {
                          WebkitBoxShadow: 'transparent !important',
                          WebkitTextFillColor: `${colorInput} !important`,
                          transition: 'background-color 9999s ease-in-out 0s',
                        },
                    }
              }
              {...rest}
            />
          )}
          {inputRightAddon}
        </InputGroup>
      </Flex>
      {error && (
        <Text color={errorColor} fontSize={13}>
          {error.message}
        </Text>
      )}
    </Flex>
  );
}
